export const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-2.amazonaws.com/us-east-2_mKClWJ8CK",
  cognitoDomain: "https://us-east-2_mKClWJ8CK.auth.us-east-2.amazoncognito.com",
  client_id: "4e9b8um7epfsqn04set3aj862m",
  redirect_uri: process.env.REACT_APP_COGNITO_REDIRECT_URI,
  logoutUri: process.env.REACT_APP_COGNITO_LOGOUT_URI,
  response_type: "code",
  scope: "email openid phone",
};